module.exports = __webpack_public_path__ + "build/img/3.7faa5c81.png";